import { Font } from "../../../../util/config-fonts";

function PgProductDescNGDesc({
  Desc = String,
  GDesc = String,
  IsAvailable = Boolean,
}) {
  return (
    <div className="pgProductDesc">
      <p style={{ margin: 0, fontWeight: "bold", fontSize: Font.MainHeading }}>
        {Desc}
      </p>
      {GDesc === "" || GDesc === "N/A" ? null : (
        <p
          style={{
            marginTop: "5px",
            fontStyle: "italic",
            fontSize: Font.Description,
          }}
        >
          {GDesc}
        </p>
      )}
      {IsAvailable ? (
        <p
          className="pgProductDescBtn"
          style={{
            color: "green",
            marginTop: 5,
            marginBottom: 0,
            fontSize: Font.Description,
          }}
        >
          Available
        </p>
      ) : (
        <p
          className="pgProductDescBtn"
          style={{
            color: "red",
            marginTop: 5,
            marginBottom: 0,
            fontSize: Font.Description,
          }}
        >
          Not Available
        </p>
      )}
    </div>
  );
}
export default PgProductDescNGDesc;
